import { render, staticRenderFns } from "./renew_item.vue?vue&type=template&id=03c2e432&scoped=true&"
import script from "./renew_item.vue?vue&type=script&lang=ts&"
export * from "./renew_item.vue?vue&type=script&lang=ts&"
import style0 from "./renew_item.vue?vue&type=style&index=0&id=03c2e432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2e432",
  null
  
)

export default component.exports